import { Component, useEffect, useLayoutEffect, useRef, useState } from "react";
import Loupe from "../static/Loupe.svg";
import loadSearch from "./loadSearch";
import "./header-search.css";

class SearchBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch() { this.props.onFailure(); }
  render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

export default function HeaderSearch() {
  const [active, setActive] = useState(false);
  const [draft, setDraft] = useState("");
  const [attempt, setAttempt] = useState(0);
  const [Search, setSearch] = useState(null);
  const [failed, setFailed] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    let mounted = true;
    loadSearch().then(module => {
      if (mounted) setSearch(() => module.default);
    }).catch(() => {
      if (mounted) setFailed(true);
    });
    return () => { mounted = false; };
  }, [active, attempt]);

  useLayoutEffect(() => {
    if (active && (!Search || failed)) inputRef.current?.focus();
  }, [active, Search, failed]);

  const warmSearch = () => { loadSearch().catch(() => {}); };
  const retry = () => {
    setSearch(null);
    setFailed(false);
    setAttempt(previous => previous + 1);
  };
  const input = (
    <div className="main-search-container" onPointerEnter={warmSearch}>
      <div className="search-autocomplete native-search">
        <img src={Loupe} alt="" className="search-loupe-icon" width="18" height="19" />
        <input ref={inputRef} aria-label="Поиск техники" role="combobox" aria-autocomplete="list" aria-expanded="false"
          placeholder="Поиск" value={draft} onChange={event => {
            setDraft(event.target.value);
            setActive(true);
          }} onFocus={warmSearch} />
      </div>
    </div>
  );
  const fallback = <div className="search-recovery">{input}
    {failed && <div className="search-error-notice" role="status">Поиск временно недоступен. <button onClick={retry}>Повторить поиск</button></div>}
  </div>;
  // Keep the input mounted while the chunk loads so typing and focus survive.
  return Search && !failed ? <SearchBoundary key={attempt} fallback={fallback} onFailure={() => setFailed(true)}>
    <Search initialValue={draft} focusOnMount />
  </SearchBoundary> : fallback;
}
